export const treatmentCategory = [
    'all',
    'General Dentistry',
    'Restorative Dentistry',
    'Orthodontics',
    'Cosmetic Dentistry',
    'Implants',
    'Facial Rejuvenation'
];

export const isEditData = [
    { id: 'allOffer', label: '', checkbox: true },
    { id: 'treatment_item.name', label: 'Treatment', align: 'left', sort: '' },
    { id: 'price', label: 'Price', align: 'left', sort: '' },
    // Its own column, not part of Price. Everything that reads `price` is
    // unchanged; this only says how the WhatsApp AI may state it.
    { id: 'aiPricing', label: 'AI pricing', align: 'left', sort: '' },
    { id: 'duration_minutes', label: 'Duration', align: 'left', sort: '' },
    { id: 'appearance', label: 'Appearance', align: 'left', sort: '' },
    { id: 'isStarred', label: 'Pin Treatment', align: 'left', sort: '' },
    { id: '', label: 'Status' },
    {id: 'offers', label: 'Offers', align: 'left', sort: '' },
    { id: '' },
];

export const noEditData = [
    { id: 'treatment_item.name', label: 'Treatment', align: 'left', sort: '' },
    { id: 'price', label: 'Price', align: 'left', sort: '' },
    { id: 'aiPricing', label: 'AI pricing', align: 'left', sort: '' },
    { id: 'duration_minutes', label: 'Duration', align: 'left', sort: '' },
    { id: 'appearance', label: 'Appearance', align: 'left', sort: '' },
    { id: 'isStarred', label: 'Pin Treatment', align: 'left', sort: '' },
    {id: 'offers', label: 'Offers', align: 'left', sort: '' },
    { id: '', label: '', align: 'left', sort: '' },
];

export const practiceTabs = [
    { value: 'All', label: 'All' },
    { value: 'Enable', label: 'Enable' },
    { value: 'Disable', label: 'Disable' },
];

// The price SHAPE travels with the number. A row that says "from GBP 279 per
// tooth" is four columns, not one, and the WhatsApp agent reads all four to
// decide whether it may quote at all — so the list has to fetch them or the
// editor below would render every treatment as POA.
export const treatmentApiFields = '?fields={enabled,id,practice,price,price_type,price_max,price_unit,price_note,price_confirmed_at,colour,icon,is_starred,treatment_item{id,name,treatment_category{id,name}}}';

export const PRICE_TYPES = [
    { value: 'POA', label: 'On request', hint: 'Quoted after a consultation. The agent will not state a figure.' },
    { value: 'FIXED', label: 'Fixed', hint: 'One price, stated as it is.' },
    { value: 'FROM', label: 'From', hint: 'A starting price. The agent says "from".' },
    { value: 'RANGE', label: 'Range', hint: 'A bottom and a top price.' },
];